module.exports = "<div id=\"chartContainerId2\"></div>\n"